
import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  IconButton,
  Button,
  TableHead,
  Modal,
  Card,
} from "@mui/material";

import Adminimg from "../../common/assests/adminimg.png";

// import './Vender.css'

import Paginations from "../../common/pagination/Paginations";
import { useNavigate } from 'react-router-dom';
import { allUserListApi, handleContactedPersonApi, updateUserApi } from '../../api';
import { useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';
import { toast } from 'react-toastify';
import TableComp from '../../common/tablecomp/TableComp';
import AllUserRow from '../../common/tablerow/AllUserRow';




const AllUserList = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const navigate=useNavigate();

 
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [loading, setLoading] = useState(false);
  

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();

  const [change,setChange]=useState(false)
  const [allUserData,setAllUserData]=useState([]);


  
  const handleAllUserList = async () => {
    try {
      let type=1
      setLoading(true);
      const response = await allUserListApi({token,currentPage,type});
      setAllUserData(response?.users|| []);
      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }finally {
      setLoading(false)
  }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };


  useEffect(() => {
    handleAllUserList();
  }, [currentPage,change]);

  
  const handleDeletUser=async(id)=>{
    const isConfirmed = window.confirm("Are you sure, you want to delete this user?");
    if (!isConfirmed) {
      return;
    }
      try {
        const response = await updateUserApi({token,id:id,account_status:4})
        setChange(!change);
        toast.success(response.message)
      } catch (error) {
        toast.error(error.message)
        console.log("ee",error);
      }
  }

  

  const handleBlockUser=async(id)=>{
    const isConfirmed = window.confirm("Are you sure, you want to Block this user?");
    if (!isConfirmed) {
      return;
    }
      try {
        const response = await updateUserApi({token,id:id,account_status:3})
        setChange(!change);
        toast.success(response.message)
      } catch (error) {
        toast.error(error.message)
        console.log("ee",error);
      }
  }

  const handleResumeUser=async(id)=>{
    const isConfirmed = window.confirm("Are you sure, you want to Resume this user?");
    if (!isConfirmed) {
      return;
    }
      try {
        const response = await updateUserApi({token,id:id,account_status:2})
        setChange(!change);
        toast.success(response.message)
      } catch (error) {
        toast.error(error.message)
        console.log("ee",error);
      }
  }

  

  const handleClickOpen = (row) => {
    navigate(`/user-management/user-information/${row?._id}`, {
      state: { data: row } 
  });
    // setSelectedRow(row);
    // setOpen(true);
  };


const titles = [
  { title: "Image" },
  { title: "Bio" },
  { title: "Email" },
  { title: "Mobile no" },
  { title: "Address" },
  { title: "Action" },
];

  return (
    <div>

{loading ? (
  <Loader variant="table" />
) : (
  <Card
  backgroundColor={"#fff"}
  borderRadius={"35px"}
  sx={{ padding: "20px", borderRadius: "25px",marginTop: "40px", marginBottom: "30px"  }}
  >
  <TableComp title={titles}>
    {allUserData?.length > 0 ? (
      allUserData?.map((item) => (               
        <AllUserRow 
          key={item?._id}
          row={item}
          handleViewMore={() => handleClickOpen(item)}
          deleteItem={()=>handleDeletUser(item?._id)}
          resumeUser={()=>handleResumeUser(item?._id)}
          blockUser={()=>handleBlockUser(item?._id)}
        />
      ))
    ) : (
      <TableRow>
        <TableCell colSpan={titles.length} align="center">
          No Data Found
        </TableCell>
      </TableRow>
    )}
  </TableComp>

  <Paginations
  totalPages={totalPages}
  currentPage={currentPage}
  onPageChange={handlePageChange}
  disabled={loading}
  />
  </Card>
)}

    </div>
  )
}

export default AllUserList